import { ReactNode } from 'react';

type FormGroupProps = {
  children?: ReactNode;
  className?: string;
};

const FormGroup = ({ children, className }: FormGroupProps) => {
  return <div className={className}>{children}</div>;
};

export default FormGroup;
